import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Button,
  Form,
  FormFeedback,
} from "reactstrap"
import ReactQuill from "react-quill-new"
import "react-quill-new/dist/quill.snow.css"
import LoaderComponent from "components/loader"
import Spinners from "components/Common/Spinner"
import * as Yup from "yup"
import { useFormik } from "formik"
import toast from "react-hot-toast"
import {
  useLazyGetAboutUsQuery,
  useUpdateFounderMessageMutation,
} from "store/api/blogs/aboutUs"
import Breadcrumb from "components/Common/Breadcrumb"
import editIcon from "../../assets/images/icons/edit.svg"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import {
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  Link,
  BlockQuote,
  Code,
  CodeBlock,
  List,
  TodoList,
  Alignment,
  Indent,
  IndentBlock,
  Image,
  ImageToolbar,
  ImageCaption,
  ImageStyle,
  ImageResize,
  ImageUpload,
  Table,
  TableToolbar,
  MediaEmbed,
  HorizontalLine,
  Highlight,
  Font,
  FontSize,
  FontColor,
  FontBackgroundColor,
  RemoveFormat,
  Undo,
  ClassicEditor,
} from "ckeditor5"

import "ckeditor5/ckeditor5.css"

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  ["link", "image"],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  // [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
]

const FounderMessage = () => {
  const [getResult, { isFetching }] = useLazyGetAboutUsQuery()
  const [update, { isLoading }] = useUpdateFounderMessageMutation()
  const [readOnly, setReadOnly] = useState(true)
  const editorRef = useRef()

  document.title = "Founder's Message | Prachay"

  const getData = async () => {
    try {
      const { success, data } = await getResult({
        key: "FOUNDER_MESSAGE",
      }).unwrap()
      if (success) {
        validation.setFieldValue("founderMessage", data.value)
      }
    } catch (error) {}
  }

  const editBlog = async (values) => {
    try {
      const { success, message } = await update({
        ...values,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "aboutUsSuccess" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  useEffect(() => {
    getData()
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { founderMessage: "" },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await editBlog(values)
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Founder's Message"} />
          <Row>
            <Col xl={12}>
              <Card>
                {isFetching ? (
                  <LoaderComponent />
                ) : (
                  <CardBody>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Row className="mb-2">
                        <Col sm={12}>
                          <div className="position-relative">
                            {readOnly && (
                              <div
                                style={{
                                  position: "absolute",
                                  zIndex: 1,
                                  inset: 0,
                                  background: "rgb(0 0 0 / 10%)",
                                }}
                              >
                                <Button
                                  type="button"
                                  onClick={() => setReadOnly(false)}
                                  style={{
                                    position: "absolute",
                                    zIndex: 2,
                                    bottom: "20px",
                                    right: "20px",
                                  }}
                                >
                                  <img className="cp" src={editIcon} alt="" />{" "}
                                  Edit
                                </Button>
                              </div>
                            )}

                            <ReactQuill
                              className="founder-message-editor"
                              theme="snow"
                              value={validation.values.founderMessage}
                              onChange={(e) =>
                                validation.setFieldValue("founderMessage", e)
                              }
                              placeholder="Update Founder's Message..."
                              modules={{
                                toolbar: toolbarOptions,
                              }}
                              readOnly={readOnly}
                            />
                            {/* <CKEditor
                              editor={ClassicEditor}
                              config={{
                                licenseKey: "GPL",
                                plugins: [
                                  Essentials,
                                  Paragraph,
                                  Heading,
                                  Bold,
                                  Italic,
                                  Underline,
                                  Strikethrough,
                                  Subscript,
                                  Superscript,
                                  Link,
                                  BlockQuote,
                                  Code,
                                  CodeBlock,
                                  List,
                                  TodoList,
                                  Alignment,
                                  Indent,
                                  IndentBlock,
                                  Image,
                                  ImageToolbar,
                                  ImageCaption,
                                  ImageStyle,
                                  ImageResize,
                                  ImageUpload,
                                  Table,
                                  TableToolbar,
                                  MediaEmbed,
                                  HorizontalLine,
                                  Highlight,
                                  Font,
                                  FontSize,
                                  FontColor,
                                  FontBackgroundColor,
                                  RemoveFormat,
                                  Undo,
                                ],
                                toolbar: {
                                  items: [
                                    "undo",
                                    "redo",
                                    "|",
                                    "heading",
                                    "|",
                                    "bold",
                                    "italic",
                                    "underline",
                                    "strikethrough",
                                    "|",
                                    "subscript",
                                    "superscript",
                                    "|",
                                    "fontSize",
                                    "fontColor",
                                    "fontBackgroundColor",
                                    "|",
                                    "highlight",
                                    "|",
                                    "link",
                                    "blockQuote",
                                    "code",
                                    "codeBlock",
                                    "|",
                                    "bulletedList",
                                    "numberedList",
                                    "todoList",
                                    "|",
                                    "indent",
                                    "alignment",
                                    "|",
                                    "insertTable",
                                    "mediaEmbed",
                                    "horizontalLine",
                                    "removeFormat",
                                  ],
                                  shouldNotGroupWhenFull: true,
                                },
                              }}
                              onReady={(editor) => {
                                editorRef.current = editor
                              }}
                              data={validation.values.founderMessage}
                              onChange={() =>
                                validation.setFieldValue(
                                  "founderMessage",
                                  editorRef.current?.getData()
                                )
                              }
                            /> */}
                          </div>
                          {validation.touched.founderMessage &&
                          validation.errors.founderMessage ? (
                            <FormFeedback type="invalid">
                              {validation.errors.founderMessage}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>

                      <Row className="justify-content-end mt-4">
                        <Col sm={12}>
                          <div className="d-flex justify-content-end align-items-center gap-3">
                            <Button
                              type="submit"
                              className="btn btn-primary w-md"
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <Spinners />
                              ) : (
                                "Update Founder's Message"
                              )}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default FounderMessage
